'use client'
import anylogger, { DBLogger, LogEntry } from '@app/anylogger'
import { useAsyncEffect, useLocalStorageOrState } from '@app/hooks'
import { readAsString, selectFile } from '@app/utils'
import { Button, OutlinedInput } from '@mui/material'
import { useCallback, useEffect, useState } from 'react'
import { buildTestTableData, ComboBox, ComboBoxProvider, FlexC, FlexR, GenericDB, TestDataTableProvider, VirtualTable } from '../src'
import { LogEntryListViewProvider, LogItemView } from './LogEntryTableProvider'

const log = anylogger('DBLogViewer')

interface DBLogViewerProps {}
export function DBLogViewer(props: DBLogViewerProps) {
	const [dbProvider, setDBProvider] = useState<ComboBoxProvider | undefined>()
	const [dbName, setDBName] = useLocalStorageOrState<string>('LogView.Table', '')
	const [pendingDbName, setPendingDbName] = useState('')
	const [filter, setFilter] = useState('')

	// const [data, setData] = useState<LogEntry[]>([])
	const [provider, setProvider] = useState(new LogEntryListViewProvider([]))

	useAsyncEffect(async () => {
		if (!pendingDbName && dbProvider) return
		const dbs = await GenericDB.getDatabases()
		const dbInfos = dbs.filter((db) => db.name && db.name.startsWith('DBLogger'))
		const dbNames = dbInfos.map((db) => db.name).filter(Boolean)
		setDBProvider(new ComboBoxProvider(dbNames, '', '', 'Select a Database'))
		if (pendingDbName) {
			setDBName(pendingDbName)
			setPendingDbName('')
		}
	}, [dbProvider, pendingDbName, setDBName])
	const dbChange = useCallback(
		async (val: string) => {
			setDBName(val)
		},
		[setDBName]
	)
	useEffect(() => {
		if (!dbName) return
		const logger = new DBLogger(dbName)
		logger
			.getAll(true, 1000)
			.then((d) => {
				log('dbName, d', dbName, d.length)
				setProvider(new LogEntryListViewProvider(d))
				// setData(d)
			})
			.finally(() => {
				logger.destroy()
			})
	}, [dbName])
	// const getRows = useCallback(() => {
	// 	if (!data || data.length == 0) return <div>No Data</div>
	// 	return data.map((d, idx) => {
	// 		return <LogItemView key={idx} data={d} />
	// 	})
	// }, [data])
	const testClick = useCallback(() => {
		log('string')
		log('array', [1, 2, 3])
		log('object', { a: 1, b: 2, c: 3, d: 4 })
		log('nested', { a: 1, b: 2, c: 3, d: 4, nested: { a: 1, b: 2, c: 3, d: 4 } })
		log('twoObjects', { a: 1, b: 2, c: 3, d: 4 }, { a: 1, b: 2, c: 3, d: 4 })
		log(
			'long string',
			'This is a super long stringt that is too big to show on one line so will cause the Lob Item to create an expansion icon so that it can be displayed in a more readable format'
		)
		log('string and object', 'string', { a: 1, b: 2, c: 3, d: 4 })
		log('object and string', { a: 1, b: 2, c: 3, d: 4 }, 'string')
	}, [])
	const deleteDatabase = useCallback(() => {
		const logger = new DBLogger(dbName)
		logger.deleteDatabase().then(() => {
			setPendingDbName('DBLogger')
		})
	}, [dbName])
	const loadFile = useCallback(async () => {
		const file = await selectFile()
		if (!file) return
		const str = await readAsString(file)
		const items = JSON.parse(str)
		console.log('items', items)

		const dbName = 'DBLogger - ' + file.name
		const logger = new DBLogger(dbName)
		logger.loadItems(items).then(() => {
			log('loaded')
			setPendingDbName(dbName)
		})
	}, [])
	const filterChange = useCallback((e: any) => {
		setFilter(e.target.value)
	}, [])
	const filterKeyDown = useCallback((e: any) => {
		if (e.key == 'Escape') setFilter('')
	}, [])
	if (!dbProvider) return <div>Loading...</div>
	return (
		<FlexC fill p="0.5em" fontSize="16px">
			<FlexR justifyContent="space-between">
				<FlexR>
					Database <ComboBox provider={dbProvider} value={dbName} onItemSelected={dbChange} />
					<Button onClick={loadFile} sx={{ fontSize: 'inherit' }}>
						Load
					</Button>
					{dbName != 'DBLogger' && (
						<Button onClick={deleteDatabase} sx={{ fontSize: 'inherit' }}>
							Delete Database
						</Button>
					)}{' '}
				</FlexR>
				{/* <Button onClick={testClick} sx={{ fontSize: 'inherit' }}>
					Test
				</Button> */}
			</FlexR>
			<FlexR>
				Filter:{' '}
				<OutlinedInput
					// inputRef={setSearchRef}
					value={filter}
					onChange={filterChange}
					size="small"
					sx={{
						flexGrow: 1,
						fontSize: 'inherit'
					}}
					onKeyDown={filterKeyDown}
				/>
			</FlexR>
			<VirtualTable fill gap="0px" provider={provider} filterText={filter} localStorageKey="DBLogViewer"></VirtualTable>
		</FlexC>
	)
}
